import { lighten } from '@material-ui/core/styles/colorManipulator'

export const styles = theme => ({
  container: {
    paddingLeft: theme.spacing.unit
  },
  textField: {
    width: 20,
    marginLeft: 5,
    marginRight: 5
  },
  highlight: {
    background: lighten(theme.palette.secondary.light, 0.85)
  },
  actions: {
    right: theme.spacing.unit * 2
  }
})



// WEBPACK FOOTER //
// ./src/components/Sources/components/SourceListItem/styles.js